import { Search } from "@mui/icons-material";
import { InputAdornment, TextField } from "@mui/material";
import { useEffect, useState } from "react";

export interface DotLegalTableControlsSearchFieldProps {
    labelSearch: string;
    value: string;
    onChange: (value: string) => void;
    useFullWidth?: boolean;
}

// Matches the standard DotLegalSearch component's look (outlined TextField, inheriting the theme's
// white background/black border) instead of @dotlegal/dotlegal-ui-components' DotLegalSearchField,
// which had its own hardcoded fill color and looked inconsistent with every other search box in the app.
function DotLegalTableControlsSearchField(props: DotLegalTableControlsSearchFieldProps) {
    const [text, setText] = useState(props.value);

    useEffect(() => {
        if (text !== props.value) props.onChange(text ?? "");
        // eslint-disable-next-line
    }, [text]);

    useEffect(() => {
        setText(props.value);
        // eslint-disable-next-line
    }, [props.value]);

    return (
        <TextField
            variant="outlined"
            color="primary"
            size="small"
            placeholder={props.labelSearch}
            value={text}
            onChange={(e) => setText(e.target.value)}
            sx={{ width: props.useFullWidth ? "100%" : 250 }}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <Search />
                    </InputAdornment>
                ),
            }}
        />
    );
}

export default DotLegalTableControlsSearchField;
